const $ = require('jquery');
const { $body, $window } = require('../lib/selectors');

const OPEN = 'js-menu-open';
const submenuOpen = 'sub-menu-open';
const activeItem = 'item-active';
const activeChildren = 'active-children';
const $hamburger = $('.menu-button');
const $menuWrapper = $('.main-nav');
const $firstLevelNavItems = $('ul.menu-level-1 > li');
const $navItemWithChildren = $('li.is-parent > span');
const $mainItemsToToggle = $('.main-menu, .top-bar');

// width at which the dekstop menu is show
const menuChange = 1000;
let lastSize = null;
let menuBool = false;

// handle clicking on menu button
$hamburger.on('click', () => {
  $mainItemsToToggle.slideToggle();
  $hamburger.toggleClass('active');
  $body.toggleClass(OPEN);
  menuBool = !menuBool;
});

$navItemWithChildren.on('click', evt => {
  if (window.innerWidth < menuChange) {
    const $this = $(evt.currentTarget);

    $(`.${activeItem}`).not($this).not($this.parents('.menu-level-2').siblings()).removeClass(activeItem).parent().removeClass(activeChildren);
    $this.toggleClass(activeItem).parent().toggleClass(activeChildren);
    // look for any open submenus that are not itself or a parent
    // and close them and remove class
    $(`.${submenuOpen}`)
      .not($this.parents())
      .not($this.next('ul'))
      .slideToggle()
      .toggleClass(submenuOpen);
    // toggle the submenu and class
    $this.next('ul').slideToggle().toggleClass(submenuOpen);
  }
});

// add function to close down menu if going from mobile to desktop
window.addEventListener('resize', closeDownMenu, {
  passive: true,
});

function closeDownMenu() {
  const thisWidth = window.innerWidth;
  if (lastSize < menuChange && thisWidth >= menuChange && menuBool) {
    $mainItemsToToggle.css('display', '');
    $hamburger.removeClass('active');
    $body.removeClass(OPEN);
    $(`.${activeItem}`).removeClass(activeItem).parent().removeClass(activeChildren);
    $(`.${submenuOpen}`).css('display', '').removeClass(submenuOpen);
    menuBool = false;
  }

  lastSize = thisWidth;
}
